import { FC } from 'react';
import { flexRender } from '@tanstack/react-table';
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from '@/components/ui/table';
import { useTranslation } from 'react-i18next';

export const AllCounterTable: FC<any> = ({ table }) => {
  const { t } = useTranslation();

  return (
    <div className="rounded-10 border bg-white overflow-hidden">
      <Table>
        <TableHeader>
          {table.getHeaderGroups().map((headerGroup: any, index: number) => (
            <TableRow className="bg-gray-100 hover:bg-gray-100" key={index}>
              {headerGroup.headers.map((header: any, i: number) => (
                <TableHead
                  className="h-10 text-[12px] font-medium text-black/60 border-b border-gray-100"
                  key={i}
                >
                  {header.isPlaceholder
                    ? null
                    : flexRender(
                        header.column.columnDef.header,
                        header.getContext(),
                      )}
                </TableHead>
              ))}
            </TableRow>
          ))}
        </TableHeader>
        <TableBody>
          {table.getRowModel().rows?.filter((row: any) => row.original !== null)
            .length ? (
            table.getRowModel().rows.map((row: any, index: number) => (
              <TableRow
                className="hover:bg-light border-b border-gray-100"
                key={index}
              >
                {row.getVisibleCells().map((cell: any, i: number) => (
                  <TableCell className="h-[52px]" key={i}>
                    {flexRender(cell.column.columnDef.cell, cell.getContext())}
                  </TableCell>
                ))}
              </TableRow>
            ))
          ) : (
            <TableRow>
              <TableCell
                colSpan={table.getAllColumns().length || 1}
                className="h-[52px] text-center"
              >
                {t('no.data')}
              </TableCell>
            </TableRow>
          )}
        </TableBody>
      </Table>
    </div>
  );
};
